import apiService from '../apiService';

/**
 * Event Form API Service
 * Handles all event form-related API calls
 */

/**
 * Create a new event form
 * @param {Object} data - Form data
 * @param {string} data.event_name - Event name
 * @param {string} data.coordinator_phone - Phone number
 * @param {number} data.club_id - Club ID
 * @param {number} data.club_email - Club email ID
 * @returns {Promise<Object>} Created event form
 */
export const createEventForm = async (data) => {
  const response = await apiService.post('/event_forms', {
    event_form: data
  });
  return response.data;
};

/**
 * Get event form by ID
 * @param {number} id - Event form ID
 * @returns {Promise<Object>} Event form details with all sections
 */
export const getEventForm = async (id) => {
  const response = await apiService.get(`/event_forms/${id}`);
  return response.data;
};

/**
 * Get club details by ID
 * @param {number} clubId - Club ID
 * @returns {Promise<Object>} Club details including name
 */
export const getClub = async (clubId) => {
  const response = await apiService.get(`/clubs/${clubId}`);
  return response.data;
};

/**
 * Get club emails for dropdown
 * @param {number} clubId - Club ID
 * @returns {Promise<Array>} Array of club emails
 */
export const getClubEmails = async (clubId) => {
  const response = await apiService.get(`/clubs/${clubId}/club_emails`);
  return response.data;
};


export const submitEventForm = async (id) => {
  const response = await apiService.post(`/event_forms/${id}/final_submission`);
  return response.data;
};

export const withdrawEventForm = async (id) => {
  const response = await apiService.post(`/event_forms/${id}/withdraw`);
  return response.data;
};

export const deleteEventForm = async (id) => {
  const response = await apiService.delete(`/event_forms/${id}`);
  return response.data;
};

export const getExpectedAttendances = async () => {
  const response = await apiService.get('/event_forms/expected_attendances');
  return response.data;
};

export default {
  createEventForm,
  getEventForm,
  getClub,
  getClubEmails,
  submitEventForm,
  withdrawEventForm,
  deleteEventForm,
  getExpectedAttendances
};
